import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "BackSpace Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-backspace-outline',
    templateUrl: './icon-backspace-outline.component.html',
    styleUrls: ['./icon-backspace-outline.component.scss'],
    standalone: false
})
export class IconBackspaceOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
